import { guestTypes } from '../constants/guestConstants'

export function isChild(contact) {
  return contact === guestTypes.child || contact.guestType === guestTypes.child
}

export function isAdult(contact) {
  return !isChild(contact)
}

export function shouldCollectGuestInformation(type) {
  return type === guestTypes.adult
}



// WEBPACK FOOTER //
// ./src/logic/guestLogic.js